export default __webpack_public_path__ + "static/media/Facebook-f_Logo-Blue-Logo.wine.3c366ccb.svg";